import { v4 as uuidv4 } from 'uuid'

const SESSION_KEY = 'session_id'
const COOKIE_DOMAIN = '.oddspulse.org'
// a session is meant to outlive everything: it is the only thing tying a browser to its saved settings
const TEN_YEARS = 10 * 365 * 24 * 60 * 60

const readCookie = () => {
  const hit = document.cookie.split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith(`${SESSION_KEY}=`))
  return hit ? decodeURIComponent(hit.slice(SESSION_KEY.length + 1)) : null
}

const writeCookie = (value) => {
  // the cookie is scoped to the parent domain so the apex and the demo subdomain share one session.
  // on localhost or a bare IP that domain is rejected, hence the plain fallback
  const secure = window.location.protocol === 'https:' ? '; secure' : ''
  const onOddspulse = window.location.hostname.endsWith('oddspulse.org')
  const domain = onOddspulse ? `; domain=${COOKIE_DOMAIN}` : ''
  document.cookie = `${SESSION_KEY}=${encodeURIComponent(value)}${domain}; path=/; max-age=${TEN_YEARS}; samesite=lax${secure}`
}

/**
 * The id the saved settings and the favourites hang off. It lives in a cookie so it survives across the
 * apex and the demo subdomain; an id from the older localStorage-only build is adopted rather than
 * replaced, so nobody loses what they already saved.
 */
export const getSessionId = () => {
  let sessionId = readCookie()

  if (!sessionId) {
    try {
      sessionId = localStorage.getItem(SESSION_KEY)
    } catch (e) {}
  }

  if (!sessionId) {
    sessionId = uuidv4()
  }

  writeCookie(sessionId)
  try {
    localStorage.setItem(SESSION_KEY, sessionId)
  } catch (e) {}

  return sessionId
}
